var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.showSpinnerLayer
    ? _c(
        "div",
        {
          key: _vm.componentKey,
          staticClass: "lexon-view-container audits-view",
        },
        [
          _c("LfHeaderTitleComponent", {
            staticClass: "header-title",
            attrs: { title: _vm.texts.title },
          }),
          _c("StaticAlertComponent", { attrs: { alert: _vm.alertData } }),
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "tabs",
                  attrs: {
                    "background-color": "transparent",
                    "hide-slider": "",
                  },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                _vm._l(_vm.tabs, function (tab, tabIndex) {
                  return _c(
                    "v-tab",
                    {
                      key: `tab-${tabIndex}`,
                      class: [
                        {
                          "change-tab-styles": _vm.$vuetify.breakpoint.mdAndUp,
                        },
                        "tab",
                      ],
                      attrs: { "active-class": "active", ripple: false },
                      on: {
                        change: function ($event) {
                          return _vm.onTabChange(tabIndex)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "tab-label" }, [
                        _vm._v(_vm._s(tab)),
                      ]),
                    ]
                  )
                }),
                1
              ),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                _vm._l(_vm.tabs, function (tab, contentIndex) {
                  return _c(
                    "v-tab-item",
                    {
                      key: `tab-${contentIndex}`,
                      staticClass: "tab-content no-padding",
                      attrs: { transition: false, "reverse-transition": false },
                    },
                    [
                      _vm.showTabSpinner
                        ? _c("SpinnerLayerComponent", {
                            staticClass: "spinner-layer-container",
                          })
                        : _c(
                            "div",
                            [
                              Object.keys(_vm.listConfiguration).length &&
                              Object.keys(_vm.serverSideData).length > 0
                                ? _c("GridTable", {
                                    attrs: {
                                      gridConfiguration:
                                        _vm.listConfiguration["Config"],
                                      title: _vm.texts.title,
                                      toolbarOptions: _vm.auditsToolbarOptions,
                                      listName: _vm.listConfiguration["Alias"],
                                      itemsData: _vm.serverSideData,
                                      context: _vm.context,
                                      itemsDataExport: _vm.serverSideExportData,
                                      useServerPagination:
                                        _vm.useServerPagination,
                                      showHeader: false,
                                      showColumnChooser: "",
                                    },
                                    on: {
                                      gridActionChange: _vm.gridActionChange,
                                      gridExportData: _vm.gridExportData,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }